export default "__VITE_ASSET__CtJYDfdy__"